import { BaseService } from './base.service';

export class RevisionHistoriesService extends BaseService {
  static get resourceEndpoint() {
    return 'revision_histories';
  }
}